import { render, staticRenderFns } from "./rolepermission.vue?vue&type=template&id=527ab8d0&"
import script from "./rolepermission.vue?vue&type=script&lang=js&"
export * from "./rolepermission.vue?vue&type=script&lang=js&"
import style0 from "./rolepermission.vue?vue&type=style&index=0&id=527ab8d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports